import ProcessBase from "../processBase";
export default class ShareProcessBase extends ProcessBase {
  setSharePageType = () => {
    // @ts-ignore
    this.isApprovePendingPage =
      // @ts-ignore
      this.isApprovePage && this.state.pageState.procedureStepStatus === "Pending";
    // @ts-ignore
    this.isApproveCompletePage =
      // @ts-ignore
      this.isApprovePage && this.state.pageState.procedureStepStatus === "Complete";
    // @ts-ignore
    this.isRevisePendingPage =
      // @ts-ignore
      this.isRevisePage && this.state.pageState.procedureStepStatus === "Pending";
    // @ts-ignore
    this.isReviseCompletePage =
      // @ts-ignore
      this.isRevisePage &&
      this.state.pageState.procedureStepStatus === "Complete" &&
      // @ts-ignore
      this.triggerTimes > 1;
    // @ts-ignore
    this.isSubmitCompletePage =
      // @ts-ignore
      this.isRevisePage &&
      this.state.pageState.procedureStepStatus === "Complete" &&
      // @ts-ignore
      this.triggerTimes === 1;
  };
}
